/* eslint-disable camelcase */
import { getDaysInMonth } from 'date-fns';
import * as Yup from 'yup';
import validateCPF from './cpfValidator';

export const validationMessages = {
  complementIsWithinTheCharLimit: 'Insira até 30 caracteres',
  requiredField: 'campo obrigatório',
  invalidCPF: 'Insira um CPF válido',
  invalidPhoneNumber: 'Telefone inválido',
  stateIsWithinTheCharLimit: 'Insira dois caracteres',
  stateMustBeUpperCase: 'Use caracteres maiúsculos',
  stateMustBeValid: 'Use uma UF válida',
};

const validStateInitialisms = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export const validationRules = {
  complementIsWithinCharLimit: Yup.mixed()
    .nullable()
    .test(
      'checks address complement length',
      validationMessages.complementIsWithinTheCharLimit,
      (value) => (value ? value.length <= 30 : true),
    ),
  requiredfield: Yup.string().required(validationMessages.requiredField),
  requiredTruePpe: Yup.string()
    .required(validationMessages.requiredField)
    .test('pep', validationMessages.requiredField, (value) => {
      return value !== 'false';
    }),
  requiredCpf: Yup.string()
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, validationMessages.invalidCPF)
    .test('validate-cpf', validationMessages.invalidCPF, (value) => {
      if (!value) {
        return true;
      }
      return validateCPF(value);
    })
    .required(validationMessages.requiredField),
  isOnlyText: Yup.string()
    .matches(/^([a-zA-Zà-úÀ-Ú]|-|\s)+$/, 'Esse campo somente aceita letras')
    .required(validationMessages.requiredField),
  requiredPropertyRegime: Yup.string().when(
    'marital_status',
    (maritalStatus) => {
      if (maritalStatus === 'married') {
        return Yup.string().required(validationMessages.requiredField);
      }
      return Yup.string();
    },
  ),
  requiredFile: Yup.mixed()
    .required(validationMessages.requiredField)
    .test('type', 'Tipo de arquivo inválido', (value) => {
      return (
        value && ['image/jpeg', 'application/pdf'].includes(value.file.type)
      );
    }),
  relatednessOtherIsRequired: Yup.string().when(
    'degree_of_relatedness',
    (degree_of_relatedness) => {
      if (degree_of_relatedness === 'other') {
        return Yup.string()
          .matches(
            /^([a-zA-Zà-úÀ-Ú]|-|\s)+$/,
            'Esse campo somente aceita letras',
          )
          .required(validationMessages.requiredField);
      }
      return Yup.string();
    },
  ),
  nationalityOtherIsRequired: Yup.string().when(
    'nationality',
    (nationality) => {
      if (nationality === 'outra') {
        return Yup.string()
          .matches(/^([a-zA-Zà-úÀ-Ú]|\s)+$/, 'Esse campo somente aceita letras')
          .required(validationMessages.requiredField);
      }
      return Yup.string();
    },
  ),
  requiredEmail: Yup.string()
    .email('Email inválido')
    .required(validationMessages.requiredField),
  requiredPhoneNumber: Yup.string()
    .min(14, validationMessages.invalidPhoneNumber)
    .max(15, validationMessages.invalidPhoneNumber),
  stateValueIsValid: Yup.string()
    .strict()
    .required(validationMessages.requiredField)
    .uppercase(validationMessages.stateMustBeUpperCase)
    .min(2, validationMessages.stateIsWithinTheCharLimit)
    .max(2, validationMessages.stateIsWithinTheCharLimit)
    .test('state', validationMessages.stateMustBeValid, (typedValue) => {
      return validStateInitialisms.some((state) => typedValue === state);
    }),
  validateBirthDate: Yup.number().when(['month', 'year'], (month, year) => {
    const dateTovalidate = new Date(year, month - 1, 1);
    return Yup.number()
      .max(getDaysInMonth(dateTovalidate), 'Data inválida')
      .required(validationMessages.requiredField);
  }),
  isMsc: Yup.boolean(),
  studentFinanceValidationCheckbox: Yup.boolean().when('isMsc', {
    is: (val: string) => JSON.parse(val),
    then: Yup.boolean()
      .required(validationMessages.requiredField)
      .oneOf([true], validationMessages.requiredField)
      .nullable(),
    otherwise: Yup.boolean().default(false).nullable(),
  }),
};
